import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start" }
const _hoisted_2 = { class: "flex-shrink text-2xl" }
const _hoisted_3 = { class: "basis-1/2 flex flex-col items-start" }
const _hoisted_4 = { class: "flex-shrink text-2xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bg-white grid grid-cols-1 place-content-between p-4 min-w-fit min-h-112", { 'h-52 min-w-336': _ctx.isAbilitato }])
  }, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex flex-shrink font-bold" }, "Alert Automatico", -1)),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-shrink text-sm" }, "Inizio attività", -1)),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.inizio), 1)
    ], 512), [
      [_vShow, _ctx.isAbilitato]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["flex justify-center", { 'justify-between':_ctx.isAbilitato }])
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-shrink text-sm" }, "Prossimo alert", -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.scadenza), 1)
      ], 512), [
        [_vShow, _ctx.isAbilitato]
      ]),
      _createVNode(_component_NextButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changeState'))),
        variant: "outline-secondary",
        class: _normalizeClass([{ 'ml-3':_ctx.isAbilitato }, "basis-1/4 self-center px-3 py-1"])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.buttonLabel), 1)
        ]),
        _: 1
      }, 8, ["class"])
    ], 2)
  ], 2))
}